import { PLAGUE_ENABLED } from "@/config/constants";
import {
	BackgroundImage,
	QuestNarrativeTypes,
} from "@/game/entities/config/quests/narrative/narrative_type";
import { NarrativeDirection, type NarrativeItem } from "@/types/quest";
import { Avatars } from "@/types/ui";
import { narrativesSide } from "./narratives_side";

const narrativesMain = new Map<number, NarrativeItem>([
	[
		101,
		{
			quest_id: 1,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_1,
				// NOTE: since user is on the right and walter is in the background on the left
				// here specifically in the username context, direction determines the position of the character, not the label
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.1.narrative_1",
			},
		},
	],
	[
		102,
		{
			quest_id: 1,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_1,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.1.narrative_2",
			},
		},
	],
	[
		103,
		{
			quest_id: 1,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_1,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.1.narrative_3",
			},
		},
	],
	[
		104,
		{
			quest_id: 1,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_1,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.1.narrative_4",
			},
		},
	],
	[
		105,
		{
			quest_id: 1,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_1,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.1.narrative_5",
			},
		},
	],
	[
		201,
		{
			quest_id: 2,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_2
					: BackgroundImage.QUEST_BG_ART_2,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.2.narrative_1",
			},
		},
	],
	[
		202,
		{
			quest_id: 2,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_2
					: BackgroundImage.QUEST_BG_ART_2,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.2.narrative_2",
			},
		},
	],
	[
		203,
		{
			quest_id: 2,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_2
					: BackgroundImage.QUEST_BG_ART_2,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.2.narrative_3",
			},
		},
	],
	[
		204,
		{
			quest_id: 2,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_2
					: BackgroundImage.QUEST_BG_ART_2,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.2.narrative_4",
			},
		},
	],
	[
		205,
		{
			quest_id: 2,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_2
					: BackgroundImage.QUEST_BG_ART_2,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.2.narrative_5",
			},
		},
	],
	[
		206,
		{
			quest_id: 2,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_2
					: BackgroundImage.QUEST_BG_ART_2,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.2.narrative_6",
			},
		},
	],
	[
		301,
		{
			quest_id: 3,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_3,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.3.narrative_1",
			},
		},
	],
	[
		302,
		{
			quest_id: 3,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_3,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.3.narrative_2",
			},
		},
	],
	[
		303,
		{
			quest_id: 3,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_3,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.3.narrative_3",
			},
		},
	],
	[
		304,
		{
			quest_id: 3,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_3,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.3.narrative_4",
			},
		},
	],
	[
		305,
		{
			quest_id: 3,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_3,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.3.narrative_5",
			},
		},
	],
	[
		401,
		{
			quest_id: 4,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_4,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.4.narrative_1",
			},
		},
	],
	[
		402,
		{
			quest_id: 4,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_4,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.4.narrative_2",
			},
		},
	],
	[
		501,
		{
			quest_id: 5,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_5,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5.narrative_1",
			},
		},
	],
	[
		502,
		{
			quest_id: 5,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_5,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5.narrative_2",
			},
		},
	],
	[
		503,
		{
			quest_id: 5,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_5,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.5.narrative_3",
			},
		},
	],
	[
		504,
		{
			quest_id: 5,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_5,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5.narrative_4",
			},
		},
	],
	[
		505,
		{
			quest_id: 5,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_5,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.5.narrative_5",
			},
		},
	],
	[
		601,
		{
			quest_id: 6,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.6.narrative_1",
			},
		},
	],
	[
		602,
		{
			quest_id: 6,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.6.narrative_2",
			},
		},
	],
	[
		603,
		{
			quest_id: 6,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.6.narrative_3",
			},
		},
	],
	[
		604,
		{
			quest_id: 6,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.6.narrative_4",
			},
		},
	],
	[
		605,
		{
			quest_id: 6,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.6.narrative_5",
			},
		},
	],
	[
		606,
		{
			quest_id: 6,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.6.narrative_6",
			},
		},
	],
	[
		701,
		{
			quest_id: 7,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_7
					: BackgroundImage.QUEST_BG_ART_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.7.narrative_1",
			},
		},
	],
	[
		702,
		{
			quest_id: 7,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_7
					: BackgroundImage.QUEST_BG_ART_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.7.narrative_2",
			},
		},
	],
	[
		703,
		{
			quest_id: 7,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_7
					: BackgroundImage.QUEST_BG_ART_7,
				character_name: "{username}",
				text: "quest.7.narrative_3",
			},
		},
	],
	[
		704,
		{
			quest_id: 7,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_7
					: BackgroundImage.QUEST_BG_ART_7,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.7.narrative_4",
			},
		},
	],
	[
		705,
		{
			quest_id: 7,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_7
					: BackgroundImage.QUEST_BG_ART_7,
				character_name: "{username}",
				text: "quest.7.narrative_5",
			},
		},
	],
	[
		706,
		{
			quest_id: 7,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_7
					: BackgroundImage.QUEST_BG_ART_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.7.narrative_6",
			},
		},
	],
	[
		707,
		{
			quest_id: 7,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_7
					: BackgroundImage.QUEST_BG_ART_7,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.7.narrative_7",
			},
		},
	],
	[
		708,
		{
			quest_id: 7,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_7
					: BackgroundImage.QUEST_BG_ART_7,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.7.narrative_8",
			},
		},
	],
	[
		709,
		{
			quest_id: 7,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_7
					: BackgroundImage.QUEST_BG_ART_7,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.7.narrative_9",
			},
		},
	],
	[
		710,
		{
			quest_id: 7,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_7
					: BackgroundImage.QUEST_BG_ART_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.7.narrative_10",
			},
		},
	],
	[
		711,
		{
			quest_id: 7,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_7
					: BackgroundImage.QUEST_BG_ART_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.7.narrative_11",
			},
		},
	],
	[
		712,
		{
			quest_id: 7,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: PLAGUE_ENABLED
					? BackgroundImage.QUEST_BG_ART_PLAGUE_7
					: BackgroundImage.QUEST_BG_ART_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.7.narrative_12",
			},
		},
	],
	/*
	[
		713,
		{
			quest_id: 7,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_7,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.7.narrative_13",
			},
		},
	],
	*/
	[
		801,
		{
			quest_id: 8,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_8,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.8.narrative_1",
			},
		},
	],
	[
		802,
		{
			quest_id: 8,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_8,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.8.narrative_2",
			},
		},
	],
	[
		803,
		{
			quest_id: 8,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_8,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.8.narrative_3",
			},
		},
	],
	[
		901,
		{
			quest_id: 9,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_9,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.9.narrative_1",
			},
		},
	],
	[
		902,
		{
			quest_id: 9,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_9,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.9.narrative_2",
			},
		},
	],
	[
		1001,
		{
			quest_id: 10,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_10,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.10.narrative_1",
			},
		},
	],
	[
		1002,
		{
			quest_id: 10,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_10,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.10.narrative_2",
			},
		},
	],
	[
		1003,
		{
			quest_id: 10,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_10,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.10.narrative_3",
			},
		},
	],
	[
		1101,
		{
			quest_id: 11,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_11,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.11.narrative_1",
			},
		},
	],
	[
		1102,
		{
			quest_id: 11,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_11,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.11.narrative_2",
			},
		},
	],
	[
		1103,
		{
			quest_id: 11,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_11,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.11.narrative_3",
			},
		},
	],
	[
		1104,
		{
			quest_id: 11,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_11,
				direction: NarrativeDirection.LEFT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.11.narrative_4",
			},
		},
	],
	[
		1105,
		{
			quest_id: 11,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_11,
				direction: NarrativeDirection.LEFT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.11.narrative_5",
			},
		},
	],
	[
		1106,
		{
			quest_id: 11,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_11,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.11.narrative_6",
			},
		},
	],
	[
		1201,
		{
			quest_id: 12,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_12,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.12.narrative_1",
			},
		},
	],
	[
		1202,
		{
			quest_id: 12,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_12,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.12.narrative_2",
			},
		},
	],
	[
		1203,
		{
			quest_id: 12,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_12,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.12.narrative_3",
			},
		},
	],
	[
		1204,
		{
			quest_id: 12,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_12,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.12.narrative_4",
			},
		},
	],
	[
		1301,
		{
			quest_id: 13,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_13,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.13.narrative_1",
			},
		},
	],
	[
		1302,
		{
			quest_id: 13,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_13,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.13.narrative_2",
			},
		},
	],
	[
		1401,
		{
			quest_id: 14,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_14,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.14.narrative_1",
			},
		},
	],
	[
		1402,
		{
			quest_id: 14,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_14,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.14.narrative_2",
			},
		},
	],
	[
		1501,
		{
			quest_id: 15,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_15,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.15.narrative_1",
			},
		},
	],
	[
		1502,
		{
			quest_id: 15,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_15,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.15.narrative_2",
			},
		},
	],
	[
		1601,
		{
			quest_id: 16,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_16,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.16.narrative_1",
			},
		},
	],
	[
		1602,
		{
			quest_id: 16,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_16,
				direction: NarrativeDirection.LEFT,
				character_name: "character.crowd",
				text: "quest.16.narrative_2",
			},
		},
	],
	[
		1603,
		{
			quest_id: 16,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_16,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.16.narrative_3",
			},
		},
	],
	[
		1604,
		{
			quest_id: 16,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_16,
				direction: NarrativeDirection.LEFT,
				character_name: "character.crowd",
				text: "quest.16.narrative_4",
			},
		},
	],
	[
		1605,
		{
			quest_id: 16,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_16,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.16.narrative_5",
			},
		},
	],
	[
		1606,
		{
			quest_id: 16,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_16,
				direction: NarrativeDirection.LEFT,
				character_name: "character.crowd",
				text: "quest.16.narrative_6",
			},
		},
	],
	[
		1607,
		{
			quest_id: 16,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_16,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.16.narrative_7",
			},
		},
	],
	[
		1608,
		{
			quest_id: 16,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_16,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.16.narrative_8",
			},
		},
	],
	[
		1701,
		{
			quest_id: 17,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_17,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.17.narrative_1",
			},
		},
	],
	[
		1702,
		{
			quest_id: 17,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_17,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.17.narrative_2",
			},
		},
	],
	[
		1703,
		{
			quest_id: 17,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_17,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.17.narrative_3",
			},
		},
	],
	[
		1704,
		{
			quest_id: 17,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_17,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.17.narrative_4",
			},
		},
	],
	[
		1705,
		{
			quest_id: 17,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_17,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.17.narrative_5",
			},
		},
	],
	[
		1706,
		{
			quest_id: 17,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_17,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.17.narrative_6",
			},
		},
	],
	[
		1707,
		{
			quest_id: 17,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_17,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.17.narrative_7",
			},
		},
	],
	[
		1708,
		{
			quest_id: 17,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_17,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.17.narrative_8",
			},
		},
	],
	[
		1709,
		{
			quest_id: 17,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_17,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.17.narrative_9",
			},
		},
	],
	[
		1710,
		{
			quest_id: 17,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_17,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.17.narrative_10",
			},
		},
	],
	[
		1711,
		{
			quest_id: 17,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_17,
				character_name: "{username}",
				text: "quest.17.narrative_11",
			},
		},
	],
	[
		1712,
		{
			quest_id: 17,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_17,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.17.narrative_12",
			},
		},
	],
	[
		1801,
		{
			quest_id: 18,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_18,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.18.narrative_1",
			},
		},
	],
	[
		1802,
		{
			quest_id: 18,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_18,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.18.narrative_2",
			},
		},
	],
	[
		1803,
		{
			quest_id: 18,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_18,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.narrative_pause.non_translatable",
			},
		},
	],
	[
		1804,
		{
			quest_id: 18,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_18,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.18.narrative_3",
			},
		},
	],
	[
		1805,
		{
			quest_id: 18,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_18,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.18.narrative_4",
			},
		},
	],
	[
		1806,
		{
			quest_id: 18,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_18,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.18.narrative_5",
			},
		},
	],
	[
		1807,
		{
			quest_id: 18,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_18,
				character_name: "{username}",
				text: "quest.18.narrative_6",
			},
		},
	],
	[
		1808,
		{
			quest_id: 18,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_18,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.18.narrative_7",
			},
		},
	],
	[
		1809,
		{
			quest_id: 18,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_18,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.18.narrative_8",
			},
		},
	],
	[
		1810,
		{
			quest_id: 18,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_18,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.18.narrative_9",
			},
		},
	],
	[
		1811,
		{
			quest_id: 18,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_18,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.18.narrative_10",
			},
		},
	],
	[
		1812,
		{
			quest_id: 18,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_18,
				direction: NarrativeDirection.LEFT,
				character_name: "character.walter.non_translatable",
				text: "quest.18.narrative_11",
			},
		},
	],
	[
		1813,
		{
			quest_id: 18,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_18,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.18.narrative_12",
			},
		},
	],
	[
		1814,
		{
			quest_id: 18,
			order_number: 14,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_18,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.18.narrative_13",
			},
		},
	],
	[
		1901,
		{
			quest_id: 19,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.19.narrative_1",
			},
		},
	],
	[
		1902,
		{
			quest_id: 19,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.lester.non_translatable",
				text: "quest.19.narrative_2",
			},
		},
	],
	[
		1903,
		{
			quest_id: 19,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.19.narrative_3",
			},
		},
	],
	[
		1904,
		{
			quest_id: 19,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.19.narrative_4",
			},
		},
	],
	[
		2001,
		{
			quest_id: 20,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_20,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.20.narrative_1",
			},
		},
	],
	[
		2101,
		{
			quest_id: 21,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_21,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.21.narrative_1",
			},
		},
	],
	[
		2201,
		{
			quest_id: 22,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_22,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.22.narrative_1",
			},
		},
	],
	[
		2202,
		{
			quest_id: 22,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_22,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.22.narrative_2",
			},
		},
	],
	[
		2203,
		{
			quest_id: 22,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_22,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.22.narrative_3",
			},
		},
	],
	[
		2301,
		{
			quest_id: 23,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.23.narrative_1",
			},
		},
	],
	[
		2302,
		{
			quest_id: 23,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.23.narrative_2",
			},
		},
	],
	[
		2303,
		{
			quest_id: 23,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.23.narrative_3",
			},
		},
	],
	[
		2304,
		{
			quest_id: 23,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.RUPERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.rupert.non_translatable",
				text: "quest.23.narrative_4",
			},
		},
	],
	[
		2305,
		{
			quest_id: 23,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.23.narrative_5",
			},
		},
	],
	[
		2306,
		{
			quest_id: 23,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.23.narrative_6",
			},
		},
	],
	[
		2307,
		{
			quest_id: 23,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.23.narrative_7",
			},
		},
	],
	[
		2308,
		{
			quest_id: 23,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.23.narrative_8",
			},
		},
	],
	[
		2401,
		{
			quest_id: 24,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.24.narrative_1",
			},
		},
	],
	[
		2402,
		{
			quest_id: 24,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.24.narrative_2",
			},
		},
	],
	[
		2403,
		{
			quest_id: 24,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.24.narrative_3",
			},
		},
	],
	[
		2404,
		{
			quest_id: 24,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.24.narrative_4",
			},
		},
	],
	[
		2405,
		{
			quest_id: 24,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.24.narrative_5",
			},
		},
	],
	[
		2406,
		{
			quest_id: 24,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.24.narrative_6",
			},
		},
	],
	[
		2501,
		{
			quest_id: 25,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_25,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.25.narrative_1",
			},
		},
	],
	[
		2502,
		{
			quest_id: 25,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_25,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.25.narrative_2",
			},
		},
	],
	[
		2503,
		{
			quest_id: 25,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_25,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.25.narrative_3",
			},
		},
	],
	[
		2504,
		{
			quest_id: 25,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_25,
				direction: NarrativeDirection.LEFT,
				character_name: "character.leonard.non_translatable",
				text: "quest.25.narrative_4",
			},
		},
	],
	[
		2505,
		{
			quest_id: 25,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_25,
				character_name: "{username}",
				text: "quest.25.narrative_5",
			},
		},
	],
	[
		2506,
		{
			quest_id: 25,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_25,
				direction: NarrativeDirection.LEFT,
				character_name: "character.leonard.non_translatable",
				text: "quest.25.narrative_6",
			},
		},
	],
	[
		2507,
		{
			quest_id: 25,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_25,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.25.narrative_7",
			},
		},
	],
	[
		2508,
		{
			quest_id: 25,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_25,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.25.narrative_8",
			},
		},
	],
	[
		2509,
		{
			quest_id: 25,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.WALTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_25,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.walter.non_translatable",
				text: "quest.25.narrative_9",
			},
		},
	],
	[
		2510,
		{
			quest_id: 25,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_25,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.25.narrative_10",
			},
		},
	],
	[
		2601,
		{
			quest_id: 26,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.26.narrative_1",
			},
		},
	],
	[
		2602,
		{
			quest_id: 26,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.26.narrative_2",
			},
		},
	],
	[
		2603,
		{
			quest_id: 26,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.26.narrative_3",
			},
		},
	],
	[
		2701,
		{
			quest_id: 27,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.27.narrative_1",
			},
		},
	],
	[
		2702,
		{
			quest_id: 27,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				character_name: "{username}",
				text: "quest.27.narrative_2",
			},
		},
	],
	[
		2703,
		{
			quest_id: 27,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.27.narrative_3",
			},
		},
	],
	[
		2704,
		{
			quest_id: 27,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.27.narrative_4",
			},
		},
	],
	[
		2705,
		{
			quest_id: 27,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.27.narrative_5",
			},
		},
	],
	[
		2706,
		{
			quest_id: 27,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.27.narrative_6",
			},
		},
	],
	[
		2707,
		{
			quest_id: 27,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.27.narrative_7",
			},
		},
	],
	[
		2708,
		{
			quest_id: 27,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				character_name: "{username}",
				text: "quest.27.narrative_8",
			},
		},
	],
	[
		2709,
		{
			quest_id: 27,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.27.narrative_9",
			},
		},
	],
	[
		2710,
		{
			quest_id: 27,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				character_name: "{username}",
				text: "quest.27.narrative_10",
			},
		},
	],
	[
		2711,
		{
			quest_id: 27,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.27.narrative_11",
			},
		},
	],
	[
		2712,
		{
			quest_id: 27,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.27.narrative_12",
			},
		},
	],
	[
		2713,
		{
			quest_id: 27,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				character_name: "{username}",
				text: "quest.27.narrative_13",
			},
		},
	],
	[
		2714,
		{
			quest_id: 27,
			order_number: 14,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.27.narrative_14",
			},
		},
	],
	[
		2715,
		{
			quest_id: 27,
			order_number: 15,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_27,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.27.narrative_15",
			},
		},
	],
	[
		2801,
		{
			quest_id: 28,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.28.narrative_1",
			},
		},
	],
	[
		2802,
		{
			quest_id: 28,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.lester.non_translatable",
				text: "quest.28.narrative_2",
			},
		},
	],
	[
		2803,
		{
			quest_id: 28,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.lester.non_translatable",
				text: "quest.28.narrative_3",
			},
		},
	],
	[
		2804,
		{
			quest_id: 28,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.28.narrative_4",
			},
		},
	],
	[
		2805,
		{
			quest_id: 28,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.28.narrative_5",
			},
		},
	],
	[
		2806,
		{
			quest_id: 28,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.leonard.non_translatable",
				text: "quest.28.narrative_6",
			},
		},
	],
	[
		2807,
		{
			quest_id: 28,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.28.narrative_7",
			},
		},
	],
	[
		2808,
		{
			quest_id: 28,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.leonard.non_translatable",
				text: "quest.28.narrative_8",
			},
		},
	],
	[
		2901,
		{
			quest_id: 29,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_29,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.29.narrative_1",
			},
		},
	],
	[
		2902,
		{
			quest_id: 29,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_29,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.29.narrative_2",
			},
		},
	],
	[
		2903,
		{
			quest_id: 29,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_29,
				character_name: "{username}",
				text: "quest.29.narrative_3",
			},
		},
	],
	[
		2904,
		{
			quest_id: 29,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_29,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.29.narrative_4",
			},
		},
	],
	[
		2905,
		{
			quest_id: 29,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_29,
				character_name: "{username}",
				text: "quest.29.narrative_5",
			},
		},
	],
	[
		2906,
		{
			quest_id: 29,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_29,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.29.narrative_6",
			},
		},
	],
	[
		2907,
		{
			quest_id: 29,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_29,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.29.narrative_7",
			},
		},
	],
	[
		3001,
		{
			quest_id: 30,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_30,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.30.narrative_1",
			},
		},
	],
	[
		3002,
		{
			quest_id: 30,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_30,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.30.narrative_2",
			},
		},
	],
	[
		3003,
		{
			quest_id: 30,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_30,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.30.narrative_3",
			},
		},
	],
	[
		3004,
		{
			quest_id: 30,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_30,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.30.narrative_4",
			},
		},
	],
	[
		3005,
		{
			quest_id: 30,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_30,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.30.narrative_5",
			},
		},
	],
	[
		3006,
		{
			quest_id: 30,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_30,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.30.narrative_6",
			},
		},
	],
	[
		3007,
		{
			quest_id: 30,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_30,
				character_name: "{username}",
				text: "quest.30.narrative_7",
			},
		},
	],
	[
		3008,
		{
			quest_id: 30,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_30,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.30.narrative_8",
			},
		},
	],
	[
		3009,
		{
			quest_id: 30,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_30,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.30.narrative_9",
			},
		},
	],
	[
		3010,
		{
			quest_id: 30,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_30,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.30.narrative_10",
			},
		},
	],
	[
		3011,
		{
			quest_id: 30,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_30,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.30.narrative_11",
			},
		},
	],
	[
		3012,
		{
			quest_id: 30,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_30,
				character_name: "{username}",
				text: "quest.30.narrative_12",
			},
		},
	],
	[
		3013,
		{
			quest_id: 30,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_30,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.30.narrative_13",
			},
		},
	],
	[
		3014,
		{
			quest_id: 30,
			order_number: 14,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_30,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.30.narrative_14",
			},
		},
	],
	[
		3101,
		{
			quest_id: 31,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.31.narrative_1",
			},
		},
	],
	[
		3102,
		{
			quest_id: 31,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.31.narrative_2",
			},
		},
	],
	[
		3103,
		{
			quest_id: 31,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.31.narrative_3",
			},
		},
	],
	[
		3104,
		{
			quest_id: 31,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.31.narrative_4",
			},
		},
	],
	[
		3201,
		{
			quest_id: 32,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.32.narrative_1",
			},
		},
	],
	[
		3202,
		{
			quest_id: 32,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.32.narrative_2",
			},
		},
	],
	[
		3301,
		{
			quest_id: 33,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.33.narrative_1",
			},
		},
	],
	[
		3302,
		{
			quest_id: 33,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.33.narrative_2",
			},
		},
	],
	[
		3401,
		{
			quest_id: 34,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_10,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.34.narrative_1",
			},
		},
	],
	[
		3402,
		{
			quest_id: 34,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_10,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.34.narrative_2",
			},
		},
	],
	[
		3403,
		{
			quest_id: 34,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_10,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.34.narrative_3",
			},
		},
	],
	[
		3404,
		{
			quest_id: 34,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_10,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.34.narrative_4",
			},
		},
	],
	[
		3501,
		{
			quest_id: 35,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.35.narrative_1",
			},
		},
	],
	[
		3502,
		{
			quest_id: 35,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.35.narrative_2",
			},
		},
	],
	[
		3503,
		{
			quest_id: 35,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				character_name: "{username}",
				text: "quest.35.narrative_3",
			},
		},
	],
	[
		3504,
		{
			quest_id: 35,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.35.narrative_4",
			},
		},
	],
	[
		3505,
		{
			quest_id: 35,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.35.narrative_5",
			},
		},
	],
	[
		3601,
		{
			quest_id: 36,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				character_name: "{username}",
				text: "quest.36.narrative_1",
			},
		},
	],
	[
		3602,
		{
			quest_id: 36,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.36.narrative_2",
			},
		},
	],
	[
		3603,
		{
			quest_id: 36,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				character_name: "{username}",
				text: "quest.36.narrative_3",
			},
		},
	],
	[
		3604,
		{
			quest_id: 36,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.36.narrative_4",
			},
		},
	],
	[
		3605,
		{
			quest_id: 36,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.36.narrative_5",
			},
		},
	],
	[
		3606,
		{
			quest_id: 36,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				character_name: "{username}",
				text: "quest.36.narrative_6",
			},
		},
	],
	[
		3607,
		{
			quest_id: 36,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.36.narrative_7",
			},
		},
	],
	[
		3608,
		{
			quest_id: 36,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.36.narrative_8",
			},
		},
	],
	[
		3609,
		{
			quest_id: 36,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				character_name: "{username}",
				text: "quest.36.narrative_9",
			},
		},
	],
	[
		3610,
		{
			quest_id: 36,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.36.narrative_10",
			},
		},
	],
	[
		3611,
		{
			quest_id: 36,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_35,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.36.narrative_11",
			},
		},
	],
	[
		3701,
		{
			quest_id: 37,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				character_name: "{username}",
				text: "quest.37.narrative_1",
			},
		},
	],
	[
		3702,
		{
			quest_id: 37,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.37.narrative_2",
			},
		},
	],
	[
		3703,
		{
			quest_id: 37,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.37.narrative_3",
			},
		},
	],
	[
		3704,
		{
			quest_id: 37,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.37.narrative_4",
			},
		},
	],
	[
		3705,
		{
			quest_id: 37,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.37.narrative_5",
			},
		},
	],
	[
		3801,
		{
			quest_id: 38,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_13,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.38.narrative_1",
			},
		},
	],
	[
		3802,
		{
			quest_id: 38,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_13,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.38.narrative_2",
			},
		},
	],
	[
		3901,
		{
			quest_id: 39,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				character_name: "{username}",
				text: "quest.39.narrative_1",
			},
		},
	],
	[
		3902,
		{
			quest_id: 39,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.39.narrative_2",
			},
		},
	],
	[
		3903,
		{
			quest_id: 39,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				character_name: "{username}",
				text: "quest.39.narrative_3",
			},
		},
	],
	[
		3904,
		{
			quest_id: 39,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.39.narrative_4",
			},
		},
	],
	[
		3905,
		{
			quest_id: 39,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.39.narrative_5",
			},
		},
	],
	[
		3906,
		{
			quest_id: 39,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.39.narrative_6",
			},
		},
	],
	[
		4001,
		{
			quest_id: 40,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.40.narrative_1",
			},
		},
	],
	[
		4002,
		{
			quest_id: 40,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.leonard.non_translatable",
				text: "quest.40.narrative_2",
			},
		},
	],
	[
		4003,
		{
			quest_id: 40,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.40.narrative_3",
			},
		},
	],
	[
		4004,
		{
			quest_id: 40,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.40.narrative_4",
			},
		},
	],
	[
		4101,
		{
			quest_id: 41,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.41.narrative_1",
			},
		},
	],
	[
		4102,
		{
			quest_id: 41,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.41.narrative_2",
			},
		},
	],
	[
		4103,
		{
			quest_id: 41,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.41.narrative_3",
			},
		},
	],
	[
		4104,
		{
			quest_id: 41,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.41.narrative_4",
			},
		},
	],
	[
		4105,
		{
			quest_id: 41,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.41.narrative_5",
			},
		},
	],
	[
		4106,
		{
			quest_id: 41,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.41.narrative_6",
			},
		},
	],
	[
		4107,
		{
			quest_id: 41,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.41.narrative_7",
			},
		},
	],
	[
		4108,
		{
			quest_id: 41,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.41.narrative_8",
			},
		},
	],
	[
		4201,
		{
			quest_id: 42,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.42.narrative_1",
			},
		},
	],
	[
		4202,
		{
			quest_id: 42,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.42.narrative_2",
			},
		},
	],
	[
		4203,
		{
			quest_id: 42,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.42.narrative_3",
			},
		},
	],
	[
		4204,
		{
			quest_id: 42,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.42.narrative_4",
			},
		},
	],
	[
		4205,
		{
			quest_id: 42,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.42.narrative_5",
			},
		},
	],
	[
		4206,
		{
			quest_id: 42,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.42.narrative_6",
			},
		},
	],
	[
		4301,
		{
			quest_id: 43,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.43.narrative_1",
			},
		},
	],
	[
		4302,
		{
			quest_id: 43,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.43.narrative_2",
			},
		},
	],
	[
		4401,
		{
			quest_id: 44,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.44.narrative_1",
			},
		},
	],
	[
		4402,
		{
			quest_id: 44,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.44.narrative_2",
			},
		},
	],
	[
		4403,
		{
			quest_id: 44,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.lester.non_translatable",
				text: "quest.44.narrative_3",
			},
		},
	],
	[
		4404,
		{
			quest_id: 44,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.44.narrative_4",
			},
		},
	],
	[
		4405,
		{
			quest_id: 44,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.lester.non_translatable",
				text: "quest.44.narrative_5",
			},
		},
	],
	[
		4406,
		{
			quest_id: 44,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.44.narrative_6",
			},
		},
	],
	[
		4407,
		{
			quest_id: 44,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.lester.non_translatable",
				text: "quest.44.narrative_7",
			},
		},
	],
	[
		4408,
		{
			quest_id: 44,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.44.narrative_8",
			},
		},
	],
	[
		4409,
		{
			quest_id: 44,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.44.narrative_9",
			},
		},
	],
	[
		4410,
		{
			quest_id: 44,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.44.narrative_10",
			},
		},
	],
	[
		4501,
		{
			quest_id: 45,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.45.narrative_1",
			},
		},
	],
	[
		4502,
		{
			quest_id: 45,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.45.narrative_2",
			},
		},
	],
	[
		4503,
		{
			quest_id: 45,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.45.narrative_3",
			},
		},
	],
	[
		4504,
		{
			quest_id: 45,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.45.narrative_4",
			},
		},
	],
	[
		4505,
		{
			quest_id: 45,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.45.narrative_5",
			},
		},
	],
	[
		4506,
		{
			quest_id: 45,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.45.narrative_6",
			},
		},
	],
	[
		4507,
		{
			quest_id: 45,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.45.narrative_7",
			},
		},
	],
	[
		4508,
		{
			quest_id: 45,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.45.narrative_8",
			},
		},
	],
	[
		4601,
		{
			quest_id: 46,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.46.narrative_1",
			},
		},
	],
	[
		4602,
		{
			quest_id: 46,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				character_name: "{username}",
				text: "quest.46.narrative_2",
			},
		},
	],
	[
		4603,
		{
			quest_id: 46,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.46.narrative_3",
			},
		},
	],
	[
		4604,
		{
			quest_id: 46,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				character_name: "{username}",
				text: "quest.46.narrative_4",
			},
		},
	],
	[
		4605,
		{
			quest_id: 46,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.46.narrative_5",
			},
		},
	],
	[
		4606,
		{
			quest_id: 46,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				direction: NarrativeDirection.LEFT,
				character_name: "character.leonard.non_translatable",
				text: "quest.46.narrative_6",
			},
		},
	],
	[
		4701,
		{
			quest_id: 47,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_47,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.47.narrative_1",
			},
		},
	],
	[
		4702,
		{
			quest_id: 47,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_47,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.47.narrative_2",
			},
		},
	],
	[
		4703,
		{
			quest_id: 47,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_47,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.47.narrative_3",
			},
		},
	],
	[
		4704,
		{
			quest_id: 47,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_47,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.47.narrative_4",
			},
		},
	],
	[
		4705,
		{
			quest_id: 47,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_47,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.47.narrative_5",
			},
		},
	],
	[
		4801,
		{
			quest_id: 48,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.48.narrative_1",
			},
		},
	],
	[
		4802,
		{
			quest_id: 48,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.48.narrative_2",
			},
		},
	],
	[
		4803,
		{
			quest_id: 48,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.48.narrative_3",
			},
		},
	],
	[
		4804,
		{
			quest_id: 48,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.48.narrative_4",
			},
		},
	],
	[
		4805,
		{
			quest_id: 48,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.48.narrative_5",
			},
		},
	],
	[
		4806,
		{
			quest_id: 48,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.48.narrative_6",
			},
		},
	],
	[
		4807,
		{
			quest_id: 48,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.48.narrative_7",
			},
		},
	],
	[
		4808,
		{
			quest_id: 48,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.48.narrative_8",
			},
		},
	],
	[
		4809,
		{
			quest_id: 48,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.48.narrative_9",
			},
		},
	],
	[
		4810,
		{
			quest_id: 48,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.48.narrative_10",
			},
		},
	],
	[
		4811,
		{
			quest_id: 48,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.48.narrative_11",
			},
		},
	],
	[
		4812,
		{
			quest_id: 48,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.48.narrative_12",
			},
		},
	],
	[
		4901,
		{
			quest_id: 49,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.49.narrative_1",
			},
		},
	],
	[
		4902,
		{
			quest_id: 49,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.apothecary",
				text: "quest.49.narrative_2",
			},
		},
	],
	[
		4903,
		{
			quest_id: 49,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.49.narrative_3",
			},
		},
	],
	[
		4904,
		{
			quest_id: 49,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.apothecary",
				text: "quest.49.narrative_4",
			},
		},
	],
	[
		4905,
		{
			quest_id: 49,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.49.narrative_5",
			},
		},
	],
	[
		4906,
		{
			quest_id: 49,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.apothecary",
				text: "quest.49.narrative_6",
			},
		},
	],
	[
		4907,
		{
			quest_id: 49,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.49.narrative_7",
			},
		},
	],
	[
		5001,
		{
			quest_id: 50,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.50.narrative_1",
			},
		},
	],
	[
		5002,
		{
			quest_id: 50,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.50.narrative_2",
			},
		},
	],
	[
		5003,
		{
			quest_id: 50,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.50.narrative_3",
			},
		},
	],
	[
		5004,
		{
			quest_id: 50,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.50.narrative_4",
			},
		},
	],
	[
		5005,
		{
			quest_id: 50,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.50.narrative_5",
			},
		},
	],
	[
		5006,
		{
			quest_id: 50,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.50.narrative_6",
			},
		},
	],
	[
		5007,
		{
			quest_id: 50,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.50.narrative_7",
			},
		},
	],
	[
		5101,
		{
			quest_id: 51,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_51,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.51.narrative_1",
			},
		},
	],
	[
		5102,
		{
			quest_id: 51,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_51,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.51.narrative_2",
			},
		},
	],
	[
		5103,
		{
			quest_id: 51,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_51,
				character_name: "{username}",
				text: "quest.51.narrative_3",
			},
		},
	],
	[
		5104,
		{
			quest_id: 51,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_51,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.51.narrative_4",
			},
		},
	],
	[
		5105,
		{
			quest_id: 51,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_51,
				character_name: "{username}",
				text: "quest.51.narrative_5",
			},
		},
	],
	[
		5106,
		{
			quest_id: 51,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_51,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.51.narrative_6",
			},
		},
	],
	[
		5201,
		{
			quest_id: 52,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.52.narrative_1",
			},
		},
	],
	[
		5202,
		{
			quest_id: 52,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.52.narrative_2",
			},
		},
	],
	[
		5203,
		{
			quest_id: 52,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.LEFT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.52.narrative_3",
			},
		},
	],
	[
		5204,
		{
			quest_id: 52,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.52.narrative_4",
			},
		},
	],
	[
		5205,
		{
			quest_id: 52,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.LEFT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.52.narrative_5",
			},
		},
	],
	[
		5206,
		{
			quest_id: 52,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.52.narrative_6",
			},
		},
	],
	[
		5207,
		{
			quest_id: 52,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.LEFT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.52.narrative_7",
			},
		},
	],
	[
		5208,
		{
			quest_id: 52,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.52.narrative_8",
			},
		},
	],
	[
		5301,
		{
			quest_id: 53,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.53.narrative_1",
			},
		},
	],
	[
		5302,
		{
			quest_id: 53,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.53.narrative_2",
			},
		},
	],
	[
		5303,
		{
			quest_id: 53,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				character_name: "{username}",
				text: "quest.53.narrative_3",
			},
		},
	],
	[
		5304,
		{
			quest_id: 53,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.53.narrative_4",
			},
		},
	],
	[
		5305,
		{
			quest_id: 53,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				character_name: "{username}",
				text: "quest.53.narrative_5",
			},
		},
	],
	[
		5306,
		{
			quest_id: 53,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.53.narrative_6",
			},
		},
	],
	[
		5307,
		{
			quest_id: 53,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				character_name: "{username}",
				text: "quest.53.narrative_7",
			},
		},
	],
	[
		5401,
		{
			quest_id: 54,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.54.narrative_1",
			},
		},
	],
	[
		5402,
		{
			quest_id: 54,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.54.narrative_2",
			},
		},
	],
	[
		5403,
		{
			quest_id: 54,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ESTHER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.esther.non_translatable",
				text: "quest.54.narrative_3",
			},
		},
	],
	[
		5404,
		{
			quest_id: 54,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ESTHER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				character_name: "{username}",
				text: "quest.54.narrative_4",
			},
		},
	],
	[
		5405,
		{
			quest_id: 54,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ESTHER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.esther.non_translatable",
				text: "quest.54.narrative_5",
			},
		},
	],
	[
		5406,
		{
			quest_id: 54,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.54.narrative_6",
			},
		},
	],
	[
		5407,
		{
			quest_id: 54,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ESTHER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.esther.non_translatable",
				text: "quest.54.narrative_7",
			},
		},
	],
	[
		5408,
		{
			quest_id: 54,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.LEFT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.54.narrative_8",
			},
		},
	],
	[
		5409,
		{
			quest_id: 54,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ESTHER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.esther.non_translatable",
				text: "quest.54.narrative_9",
			},
		},
	],
	[
		5410,
		{
			quest_id: 54,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ESTHER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				character_name: "{username}",
				text: "quest.54.narrative_10",
			},
		},
	],
	[
		5411,
		{
			quest_id: 54,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.54.narrative_11",
			},
		},
	],
	[
		5412,
		{
			quest_id: 54,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ESTHER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.esther.non_translatable",
				text: "quest.54.narrative_12",
			},
		},
	],
	[
		5501,
		{
			quest_id: 55,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.55.narrative_1",
			},
		},
	],
	[
		5502,
		{
			quest_id: 55,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ESTHER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.esther.non_translatable",
				text: "quest.55.narrative_2",
			},
		},
	],
	[
		5503,
		{
			quest_id: 55,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.55.narrative_3",
			},
		},
	],
	[
		5504,
		{
			quest_id: 55,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ESTHER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.esther.non_translatable",
				text: "quest.55.narrative_4",
			},
		},
	],
	[
		5505,
		{
			quest_id: 55,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ESTHER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.esther.non_translatable",
				text: "quest.55.narrative_5",
			},
		},
	],
	[
		5506,
		{
			quest_id: 55,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ESTHER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				character_name: "{username}",
				text: "quest.55.narrative_6",
			},
		},
	],
	[
		5507,
		{
			quest_id: 55,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.55.narrative_7",
			},
		},
	],
	[
		5508,
		{
			quest_id: 55,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ESTHER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_54,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.esther.non_translatable",
				text: "quest.55.narrative_8",
			},
		},
	],
	[
		5601,
		{
			quest_id: 56,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_56,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.56.narrative_1",
			},
		},
	],
	[
		5602,
		{
			quest_id: 56,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_56,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.56.narrative_2",
			},
		},
	],
	[
		5603,
		{
			quest_id: 56,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_56,
				direction: NarrativeDirection.LEFT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.56.narrative_3",
			},
		},
	],
	[
		5604,
		{
			quest_id: 56,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_56,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.56.narrative_4",
			},
		},
	],
	[
		5605,
		{
			quest_id: 56,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_56,
				direction: NarrativeDirection.LEFT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.56.narrative_5",
			},
		},
	],
	[
		5606,
		{
			quest_id: 56,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_56,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.56.narrative_6",
			},
		},
	],
	[
		5607,
		{
			quest_id: 56,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_56,
				direction: NarrativeDirection.LEFT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.56.narrative_7",
			},
		},
	],
	[
		5701,
		{
			quest_id: 57,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.57.narrative_1",
			},
		},
	],
	[
		5702,
		{
			quest_id: 57,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.57.narrative_2",
			},
		},
	],
	[
		5703,
		{
			quest_id: 57,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.57.narrative_3",
			},
		},
	],
	[
		5704,
		{
			quest_id: 57,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.57.narrative_4",
			},
		},
	],
	[
		5705,
		{
			quest_id: 57,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.57.narrative_5",
			},
		},
	],
	[
		5706,
		{
			quest_id: 57,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.57.narrative_6",
			},
		},
	],
	[
		5707,
		{
			quest_id: 57,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.57.narrative_7",
			},
		},
	],
	[
		5801,
		{
			quest_id: 58,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.58.narrative_1",
			},
		},
	],
	[
		5802,
		{
			quest_id: 58,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.58.narrative_2",
			},
		},
	],
	[
		5803,
		{
			quest_id: 58,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				character_name: "{username}",
				text: "quest.58.narrative_3",
			},
		},
	],
	[
		5804,
		{
			quest_id: 58,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.58.narrative_4",
			},
		},
	],
	[
		5901,
		{
			quest_id: 59,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.59.narrative_1",
			},
		},
	],
	[
		5902,
		{
			quest_id: 59,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.59.narrative_2",
			},
		},
	],
	[
		5903,
		{
			quest_id: 59,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				character_name: "{username}",
				text: "quest.59.narrative_3",
			},
		},
	],
	[
		5904,
		{
			quest_id: 59,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.59.narrative_4",
			},
		},
	],
	[
		5905,
		{
			quest_id: 59,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.59.narrative_5",
			},
		},
	],
	[
		5906,
		{
			quest_id: 59,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.59.narrative_6",
			},
		},
	],
	[
		5907,
		{
			quest_id: 59,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.59.narrative_7",
			},
		},
	],
	[
		5908,
		{
			quest_id: 59,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.59.narrative_8",
			},
		},
	],
	[
		6001,
		{
			quest_id: 60,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.60.narrative_1",
			},
		},
	],
	[
		6002,
		{
			quest_id: 60,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ESTHER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.esther.non_translatable",
				text: "quest.60.narrative_2",
			},
		},
	],
	[
		6003,
		{
			quest_id: 60,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.60.narrative_3",
			},
		},
	],
	[
		6004,
		{
			quest_id: 60,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				character_name: "{username}",
				text: "quest.60.narrative_4",
			},
		},
	],
	[
		6005,
		{
			quest_id: 60,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.LEFT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.60.narrative_5",
			},
		},
	],
	[
		6006,
		{
			quest_id: 60,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				character_name: "{username}",
				text: "quest.60.narrative_6",
			},
		},
	],
	[
		6007,
		{
			quest_id: 60,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.LEFT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.60.narrative_7",
			},
		},
	],
	[
		6008,
		{
			quest_id: 60,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				character_name: "{username}",
				text: "quest.60.narrative_8",
			},
		},
	],
	[
		6101,
		{
			quest_id: 61,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.61.narrative_1",
			},
		},
	],
	[
		6102,
		{
			quest_id: 61,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.61.narrative_2",
			},
		},
	],
	[
		6103,
		{
			quest_id: 61,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_57,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.61.narrative_3",
			},
		},
	],
	[
		6201,
		{
			quest_id: 62,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.62.narrative_1",
			},
		},
	],
	[
		6202,
		{
			quest_id: 62,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_37,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.62.narrative_2",
			},
		},
	],
	[
		6301,
		{
			quest_id: 63,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.63.narrative_1",
			},
		},
	],
	[
		6302,
		{
			quest_id: 63,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.63.narrative_2",
			},
		},
	],
	[
		6303,
		{
			quest_id: 63,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.63.narrative_3",
			},
		},
	],
	[
		6304,
		{
			quest_id: 63,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.63.narrative_4",
			},
		},
	],
	[
		6401,
		{
			quest_id: 64,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.64.narrative_1",
			},
		},
	],
	[
		6402,
		{
			quest_id: 64,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.64.narrative_2",
			},
		},
	],
	[
		6403,
		{
			quest_id: 64,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.64.narrative_3",
			},
		},
	],
	[
		6404,
		{
			quest_id: 64,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.64.narrative_4",
			},
		},
	],
	[
		6405,
		{
			quest_id: 64,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.64.narrative_5",
			},
		},
	],
	[
		6406,
		{
			quest_id: 64,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.moira.non_translatable",
				text: "quest.64.narrative_6",
			},
		},
	],
	[
		6501,
		{
			quest_id: 65,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.65.narrative_1",
			},
		},
	],
	[
		6502,
		{
			quest_id: 65,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.moira.non_translatable",
				text: "quest.65.narrative_2",
			},
		},
	],
	[
		6503,
		{
			quest_id: 65,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.65.narrative_3",
			},
		},
	],
	[
		6504,
		{
			quest_id: 65,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.moira.non_translatable",
				text: "quest.65.narrative_4",
			},
		},
	],
	[
		6505,
		{
			quest_id: 65,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.65.narrative_5",
			},
		},
	],
	[
		6506,
		{
			quest_id: 65,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.moira.non_translatable",
				text: "quest.65.narrative_6",
			},
		},
	],
	[
		6507,
		{
			quest_id: 65,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.65.narrative_7",
			},
		},
	],
	[
		6508,
		{
			quest_id: 65,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.leonard.non_translatable",
				text: "quest.65.narrative_8",
			},
		},
	],
	[
		6509,
		{
			quest_id: 65,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.65.narrative_9",
			},
		},
	],
	[
		6510,
		{
			quest_id: 65,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.65.narrative_10",
			},
		},
	],
	[
		6511,
		{
			quest_id: 65,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.65.narrative_11",
			},
		},
	],
	[
		6601,
		{
			quest_id: 66,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.66.narrative_1",
			},
		},
	],
	[
		6701,
		{
			quest_id: 67,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.67.narrative_1",
			},
		},
	],
	[
		6702,
		{
			quest_id: 67,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.67.narrative_2",
			},
		},
	],
	[
		6801,
		{
			quest_id: 68,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.68.narrative_1",
			},
		},
	],
	[
		6802,
		{
			quest_id: 68,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.68.narrative_2",
			},
		},
	],
	[
		6803,
		{
			quest_id: 68,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.68.narrative_3",
			},
		},
	],
	[
		6804,
		{
			quest_id: 68,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.68.narrative_4",
			},
		},
	],
	[
		6805,
		{
			quest_id: 68,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.68.narrative_5",
			},
		},
	],
	[
		6901,
		{
			quest_id: 69,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_69,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.moira.non_translatable",
				text: "quest.69.narrative_1",
			},
		},
	],
	[
		6902,
		{
			quest_id: 69,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_69,
				character_name: "{username}",
				text: "quest.69.narrative_2",
			},
		},
	],
	[
		6903,
		{
			quest_id: 69,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_69,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.69.narrative_3",
			},
		},
	],
	[
		6904,
		{
			quest_id: 69,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_69,
				character_name: "{username}",
				text: "quest.69.narrative_4",
			},
		},
	],
	[
		6905,
		{
			quest_id: 69,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_69,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.moira.non_translatable",
				text: "quest.69.narrative_5",
			},
		},
	],
	[
		6906,
		{
			quest_id: 69,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_69,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.69.narrative_6",
			},
		},
	],
	[
		6907,
		{
			quest_id: 69,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_69,
				character_name: "{username}",
				text: "quest.69.narrative_7",
			},
		},
	],
	[
		6908,
		{
			quest_id: 69,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_69,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.moira.non_translatable",
				text: "quest.69.narrative_8",
			},
		},
	],
	[
		6909,
		{
			quest_id: 69,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_69,
				character_name: "{username}",
				text: "quest.69.narrative_9",
			},
		},
	],
	[
		7001,
		{
			quest_id: 70,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.70.narrative_1",
			},
		},
	],
	[
		7002,
		{
			quest_id: 70,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.70.narrative_2",
			},
		},
	],
	[
		7003,
		{
			quest_id: 70,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.70.narrative_3",
			},
		},
	],
	[
		7004,
		{
			quest_id: 70,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.70.narrative_4",
			},
		},
	],
	[
		7005,
		{
			quest_id: 70,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.70.narrative_5",
			},
		},
	],
	[
		7101,
		{
			quest_id: 71,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.71.narrative_1",
			},
		},
	],
	[
		7102,
		{
			quest_id: 71,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.71.narrative_2",
			},
		},
	],
	[
		7103,
		{
			quest_id: 71,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.71.narrative_3",
			},
		},
	],
	[
		7104,
		{
			quest_id: 71,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ESTHER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.esther.non_translatable",
				text: "quest.71.narrative_4",
			},
		},
	],
	[
		7105,
		{
			quest_id: 71,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.moira.non_translatable",
				text: "quest.71.narrative_5",
			},
		},
	],
	[
		7106,
		{
			quest_id: 71,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.71.narrative_6",
			},
		},
	],
	[
		7107,
		{
			quest_id: 71,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.71.narrative_7",
			},
		},
	],
	[
		7108,
		{
			quest_id: 71,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.71.narrative_8",
			},
		},
	],
	[
		7109,
		{
			quest_id: 71,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.71.narrative_9",
			},
		},
	],
	[
		7110,
		{
			quest_id: 71,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.71.narrative_10",
			},
		},
	],
	[
		7111,
		{
			quest_id: 71,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.71.narrative_11",
			},
		},
	],
	[
		7112,
		{
			quest_id: 71,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.71.narrative_12",
			},
		},
	],
	[
		7113,
		{
			quest_id: 71,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.71.narrative_13",
			},
		},
	],
	[
		7114,
		{
			quest_id: 71,
			order_number: 14,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.71.narrative_14",
			},
		},
	],
	[
		7115,
		{
			quest_id: 71,
			order_number: 15,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.71.narrative_15",
			},
		},
	],
	[
		7201,
		{
			quest_id: 72,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.72.narrative_1",
			},
		},
	],
	[
		7202,
		{
			quest_id: 72,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.72.narrative_2",
			},
		},
	],
	[
		7203,
		{
			quest_id: 72,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.72.narrative_3",
			},
		},
	],
	[
		7204,
		{
			quest_id: 72,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.72.narrative_4",
			},
		},
	],
	[
		7205,
		{
			quest_id: 72,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.72.narrative_5",
			},
		},
	],
	[
		7206,
		{
			quest_id: 72,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.72.narrative_6",
			},
		},
	],
	[
		7207,
		{
			quest_id: 72,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.72.narrative_7",
			},
		},
	],
	[
		7208,
		{
			quest_id: 72,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.72.narrative_8",
			},
		},
	],
	[
		7209,
		{
			quest_id: 72,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.72.narrative_9",
			},
		},
	],
	[
		7210,
		{
			quest_id: 72,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.72.narrative_10",
			},
		},
	],
	[
		7211,
		{
			quest_id: 72,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.72.narrative_11",
			},
		},
	],
	[
		7212,
		{
			quest_id: 72,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.72.narrative_12",
			},
		},
	],
	[
		7213,
		{
			quest_id: 72,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.72.narrative_13",
			},
		},
	],
	[
		7214,
		{
			quest_id: 72,
			order_number: 14,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.72.narrative_14",
			},
		},
	],
	[
		7215,
		{
			quest_id: 72,
			order_number: 15,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.72.narrative_15",
			},
		},
	],
	[
		7301,
		{
			quest_id: 73,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.73.narrative_1",
			},
		},
	],
	[
		7302,
		{
			quest_id: 73,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.73.narrative_2",
			},
		},
	],
	[
		7303,
		{
			quest_id: 73,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.73.narrative_3",
			},
		},
	],
	[
		7304,
		{
			quest_id: 73,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.73.narrative_4",
			},
		},
	],
	[
		7305,
		{
			quest_id: 73,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.73.narrative_5",
			},
		},
	],
	[
		7306,
		{
			quest_id: 73,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.73.narrative_6",
			},
		},
	],
	[
		7307,
		{
			quest_id: 73,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.73.narrative_7",
			},
		},
	],
	[
		7308,
		{
			quest_id: 73,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.73.narrative_8",
			},
		},
	],
	[
		7309,
		{
			quest_id: 73,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.73.narrative_9",
			},
		},
	],
	[
		7310,
		{
			quest_id: 73,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.73.narrative_10",
			},
		},
	],
	[
		7311,
		{
			quest_id: 73,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.73.narrative_11",
			},
		},
	],
	[
		7312,
		{
			quest_id: 73,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.73.narrative_12",
			},
		},
	],
	[
		7313,
		{
			quest_id: 73,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.73.narrative_13",
			},
		},
	],
	[
		7401,
		{
			quest_id: 74,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.74.narrative_1",
			},
		},
	],
	[
		7402,
		{
			quest_id: 74,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.74.narrative_2",
			},
		},
	],
	[
		7403,
		{
			quest_id: 74,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.74.narrative_3",
			},
		},
	],
	[
		7404,
		{
			quest_id: 74,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.74.narrative_4",
			},
		},
	],
	[
		7405,
		{
			quest_id: 74,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.74.narrative_5",
			},
		},
	],
	[
		7406,
		{
			quest_id: 74,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.74.narrative_6",
			},
		},
	],
	[
		7407,
		{
			quest_id: 74,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.74.narrative_7",
			},
		},
	],
	[
		7408,
		{
			quest_id: 74,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.74.narrative_8",
			},
		},
	],
	[
		7409,
		{
			quest_id: 74,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.74.narrative_9",
			},
		},
	],
	[
		7410,
		{
			quest_id: 74,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.74.narrative_10",
			},
		},
	],
	[
		7411,
		{
			quest_id: 74,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.74.narrative_11",
			},
		},
	],
	[
		7412,
		{
			quest_id: 74,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.74.narrative_12",
			},
		},
	],
	[
		7501,
		{
			quest_id: 75,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.75.narrative_1",
			},
		},
	],
	[
		7502,
		{
			quest_id: 75,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.75.narrative_2",
			},
		},
	],
	[
		7503,
		{
			quest_id: 75,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.75.narrative_3",
			},
		},
	],
	[
		7504,
		{
			quest_id: 75,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.75.narrative_4",
			},
		},
	],
	[
		7505,
		{
			quest_id: 75,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.75.narrative_5",
			},
		},
	],
	[
		7506,
		{
			quest_id: 75,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.75.narrative_6",
			},
		},
	],
	[
		7507,
		{
			quest_id: 75,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.75.narrative_7",
			},
		},
	],
	[
		7508,
		{
			quest_id: 75,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.75.narrative_8",
			},
		},
	],
	[
		7509,
		{
			quest_id: 75,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.75.narrative_9",
			},
		},
	],
	[
		7510,
		{
			quest_id: 75,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.75.narrative_10",
			},
		},
	],
	[
		7511,
		{
			quest_id: 75,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.75.narrative_11",
			},
		},
	],
	[
		7512,
		{
			quest_id: 75,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.75.narrative_12",
			},
		},
	],
	[
		7513,
		{
			quest_id: 75,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.75.narrative_13",
			},
		},
	],
	[
		7601,
		{
			quest_id: 76,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.76.narrative_1",
			},
		},
	],
	[
		7602,
		{
			quest_id: 76,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.76.narrative_2",
			},
		},
	],
	[
		7603,
		{
			quest_id: 76,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.76.narrative_3",
			},
		},
	],
	[
		7604,
		{
			quest_id: 76,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.76.narrative_4",
			},
		},
	],
	[
		7605,
		{
			quest_id: 76,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.76.narrative_5",
			},
		},
	],
	[
		7701,
		{
			quest_id: 77,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.77.narrative_1",
			},
		},
	],
	[
		7702,
		{
			quest_id: 77,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.77.narrative_2",
			},
		},
	],
	[
		7703,
		{
			quest_id: 77,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.moira.non_translatable",
				text: "quest.77.narrative_3",
			},
		},
	],
	[
		7704,
		{
			quest_id: 77,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.77.narrative_4",
			},
		},
	],
	[
		7705,
		{
			quest_id: 77,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.77.narrative_5",
			},
		},
	],
	[
		7706,
		{
			quest_id: 77,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.77.narrative_6",
			},
		},
	],
	[
		7707,
		{
			quest_id: 77,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.77.narrative_7",
			},
		},
	],
	[
		7708,
		{
			quest_id: 77,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.77.narrative_8",
			},
		},
	],
	[
		7709,
		{
			quest_id: 77,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.moira.non_translatable",
				text: "quest.77.narrative_9",
			},
		},
	],
	[
		7710,
		{
			quest_id: 77,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.77.narrative_10",
			},
		},
	],
	[
		7711,
		{
			quest_id: 77,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.77.narrative_11",
			},
		},
	],
	[
		7712,
		{
			quest_id: 77,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.moira.non_translatable",
				text: "quest.77.narrative_12",
			},
		},
	],
	[
		7801,
		{
			quest_id: 78,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.78.narrative_1",
			},
		},
	],
	[
		7802,
		{
			quest_id: 78,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.78.narrative_2",
			},
		},
	],
	[
		7803,
		{
			quest_id: 78,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.78.narrative_3",
			},
		},
	],
	[
		7804,
		{
			quest_id: 78,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.78.narrative_4",
			},
		},
	],
	[
		7805,
		{
			quest_id: 78,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.78.narrative_5",
			},
		},
	],
	[
		7806,
		{
			quest_id: 78,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.78.narrative_6",
			},
		},
	],
	[
		7807,
		{
			quest_id: 78,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.78.narrative_7",
			},
		},
	],
	[
		7808,
		{
			quest_id: 78,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.78.narrative_8",
			},
		},
	],
	[
		7809,
		{
			quest_id: 78,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.78.narrative_9",
			},
		},
	],
	[
		7810,
		{
			quest_id: 78,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.78.narrative_10",
			},
		},
	],
	[
		7811,
		{
			quest_id: 78,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.78.narrative_11",
			},
		},
	],
	[
		7812,
		{
			quest_id: 78,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.78.narrative_12",
			},
		},
	],
	[
		7813,
		{
			quest_id: 78,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.78.narrative_13",
			},
		},
	],
	[
		7901,
		{
			quest_id: 79,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.79.narrative_1",
			},
		},
	],
	[
		7902,
		{
			quest_id: 79,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.79.narrative_2",
			},
		},
	],
	[
		7903,
		{
			quest_id: 79,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.79.narrative_3",
			},
		},
	],
	[
		7904,
		{
			quest_id: 79,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.79.narrative_4",
			},
		},
	],
	[
		7905,
		{
			quest_id: 79,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.79.narrative_5",
			},
		},
	],
	[
		7906,
		{
			quest_id: 79,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.79.narrative_6",
			},
		},
	],
	[
		7907,
		{
			quest_id: 79,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.79.narrative_7",
			},
		},
	],
	[
		7908,
		{
			quest_id: 79,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.79.narrative_8",
			},
		},
	],
	[
		7909,
		{
			quest_id: 79,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.79.narrative_9",
			},
		},
	],
	[
		7910,
		{
			quest_id: 79,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.79.narrative_10",
			},
		},
	],
	[
		8001,
		{
			quest_id: 80,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_80,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.80.narrative_1",
			},
		},
	],
	[
		8002,
		{
			quest_id: 80,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_80,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.80.narrative_2",
			},
		},
	],
	[
		8003,
		{
			quest_id: 80,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_80,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.80.narrative_3",
			},
		},
	],
	[
		8004,
		{
			quest_id: 80,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_80,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.80.narrative_4",
			},
		},
	],
	[
		8005,
		{
			quest_id: 80,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_80,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.80.narrative_5",
			},
		},
	],
	[
		8006,
		{
			quest_id: 80,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_80,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.moira.non_translatable",
				text: "quest.80.narrative_6",
			},
		},
	],
	[
		8007,
		{
			quest_id: 80,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_80,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.moira.non_translatable",
				text: "quest.80.narrative_7",
			},
		},
	],
	[
		8008,
		{
			quest_id: 80,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_80,
				character_name: "{username}",
				text: "quest.80.narrative_8",
			},
		},
	],
	[
		8009,
		{
			quest_id: 80,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_80,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.moira.non_translatable",
				text: "quest.80.narrative_9",
			},
		},
	],
	[
		8010,
		{
			quest_id: 80,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_80,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.moira.non_translatable",
				text: "quest.80.narrative_10",
			},
		},
	],
	[
		8011,
		{
			quest_id: 80,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.MOIRA,
				backgroundImage: BackgroundImage.QUEST_BG_ART_80,
				character_name: "{username}",
				text: "quest.80.narrative_11",
			},
		},
	],
	[
		8101,
		{
			quest_id: 81,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.81.narrative_1",
			},
		},
	],
	[
		8102,
		{
			quest_id: 81,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.81.narrative_2",
			},
		},
	],
	[
		8103,
		{
			quest_id: 81,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.81.narrative_3",
			},
		},
	],
	[
		8104,
		{
			quest_id: 81,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.81.narrative_4",
			},
		},
	],
	[
		8201,
		{
			quest_id: 82,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.82.narrative_1",
			},
		},
	],
	[
		8202,
		{
			quest_id: 82,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.leonard.non_translatable",
				text: "quest.82.narrative_2",
			},
		},
	],
	[
		8203,
		{
			quest_id: 82,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GERTRUDE,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.LEFT,
				character_name: "character.gertrude.non_translatable",
				text: "quest.82.narrative_3",
			},
		},
	],
	[
		8204,
		{
			quest_id: 82,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.THRASIUS,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.thrasius.non_translatable",
				text: "quest.82.narrative_4",
			},
		},
	],
	[
		8205,
		{
			quest_id: 82,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				character_name: "{username}",
				text: "quest.82.narrative_5",
			},
		},
	],
	[
		8206,
		{
			quest_id: 82,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.LEFT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.82.narrative_6",
			},
		},
	],
	[
		8207,
		{
			quest_id: 82,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				character_name: "{username}",
				text: "quest.82.narrative_7",
			},
		},
	],
	[
		8208,
		{
			quest_id: 82,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				character_name: "{username}",
				text: "quest.82.narrative_8",
			},
		},
	],
	[
		8209,
		{
			quest_id: 82,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.LEFT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.82.narrative_9",
			},
		},
	],
	[
		8210,
		{
			quest_id: 82,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.82.narrative_10",
			},
		},
	],
	[
		8211,
		{
			quest_id: 82,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.82.narrative_11",
			},
		},
	],
	[
		8301,
		{
			quest_id: 83,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_83,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.83.narrative_1",
			},
		},
	],
	[
		8302,
		{
			quest_id: 83,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_83,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.83.narrative_2",
			},
		},
	],
	[
		8303,
		{
			quest_id: 83,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_83,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.83.narrative_3",
			},
		},
	],
	[
		8304,
		{
			quest_id: 83,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_83,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.83.narrative_4",
			},
		},
	],
	[
		8401,
		{
			quest_id: 84,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.84.narrative_1",
			},
		},
	],
	[
		8402,
		{
			quest_id: 84,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.84.narrative_2",
			},
		},
	],
	[
		8403,
		{
			quest_id: 84,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				character_name: "{username}",
				text: "quest.84.narrative_3",
			},
		},
	],
	[
		8404,
		{
			quest_id: 84,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.lester.non_translatable",
				text: "quest.84.narrative_4",
			},
		},
	],
	[
		8405,
		{
			quest_id: 84,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				character_name: "{username}",
				text: "quest.84.narrative_5",
			},
		},
	],
	[
		8406,
		{
			quest_id: 84,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.lester.non_translatable",
				text: "quest.84.narrative_6",
			},
		},
	],
	[
		8407,
		{
			quest_id: 84,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				character_name: "{username}",
				text: "quest.84.narrative_7",
			},
		},
	],
	[
		8408,
		{
			quest_id: 84,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.lester.non_translatable",
				text: "quest.84.narrative_8",
			},
		},
	],
	[
		8409,
		{
			quest_id: 84,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				character_name: "{username}",
				text: "quest.84.narrative_9",
			},
		},
	],
	[
		8410,
		{
			quest_id: 84,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.lester.non_translatable",
				text: "quest.84.narrative_10",
			},
		},
	],
	[
		8411,
		{
			quest_id: 84,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.84.narrative_11",
			},
		},
	],
	[
		8501,
		{
			quest_id: 85,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.85.narrative_1",
			},
		},
	],
	[
		8502,
		{
			quest_id: 85,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.85.narrative_2",
			},
		},
	],
	[
		8503,
		{
			quest_id: 85,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.85.narrative_3",
			},
		},
	],
	[
		8504,
		{
			quest_id: 85,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.85.narrative_4",
			},
		},
	],
	[
		8505,
		{
			quest_id: 85,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.message",
				text: "quest.85.narrative_5",
			},
		},
	],
	[
		8506,
		{
			quest_id: 85,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.85.narrative_6",
			},
		},
	],
	[
		8601,
		{
			quest_id: 86,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.86.narrative_1",
			},
		},
	],
	[
		8602,
		{
			quest_id: 86,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.86.narrative_2",
			},
		},
	],
	[
		8603,
		{
			quest_id: 86,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.unknown_person",
				text: "quest.86.narrative_3",
			},
		},
	],
	[
		8604,
		{
			quest_id: 86,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				character_name: "{username}",
				text: "quest.86.narrative_4",
			},
		},
	],
	[
		8605,
		{
			quest_id: 86,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.86.narrative_5",
			},
		},
	],
	[
		8606,
		{
			quest_id: 86,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				character_name: "{username}",
				text: "quest.86.narrative_6",
			},
		},
	],
	[
		8607,
		{
			quest_id: 86,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.86.narrative_7",
			},
		},
	],
	[
		8608,
		{
			quest_id: 86,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				character_name: "{username}",
				text: "quest.86.narrative_8",
			},
		},
	],
	[
		8609,
		{
			quest_id: 86,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.86.narrative_9",
			},
		},
	],
	[
		8610,
		{
			quest_id: 86,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				character_name: "{username}",
				text: "quest.86.narrative_10",
			},
		},
	],
	[
		8611,
		{
			quest_id: 86,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.86.narrative_11",
			},
		},
	],
	[
		8612,
		{
			quest_id: 86,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				character_name: "{username}",
				text: "quest.86.narrative_12",
			},
		},
	],
	[
		8613,
		{
			quest_id: 86,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.86.narrative_13",
			},
		},
	],
	[
		8614,
		{
			quest_id: 86,
			order_number: 14,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				character_name: "{username}",
				text: "quest.86.narrative_14",
			},
		},
	],
	[
		8615,
		{
			quest_id: 86,
			order_number: 15,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_86,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.86.narrative_15",
			},
		},
	],
	[
		8701,
		{
			quest_id: 87,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.87.narrative_1",
			},
		},
	],
	[
		8702,
		{
			quest_id: 87,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.87.narrative_2",
			},
		},
	],
	[
		8703,
		{
			quest_id: 87,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.87.narrative_3",
			},
		},
	],
	[
		8801,
		{
			quest_id: 88,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.88.narrative_1",
			},
		},
	],
	[
		8802,
		{
			quest_id: 88,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.88.narrative_2",
			},
		},
	],
	[
		8803,
		{
			quest_id: 88,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.88.narrative_3",
			},
		},
	],
	[
		8804,
		{
			quest_id: 88,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.88.narrative_4",
			},
		},
	],
	[
		8901,
		{
			quest_id: 89,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.89.narrative_1",
			},
		},
	],
	[
		8902,
		{
			quest_id: 89,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.89.narrative_2",
			},
		},
	],
	[
		8903,
		{
			quest_id: 89,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_84,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.89.narrative_3",
			},
		},
	],
	[
		9001,
		{
			quest_id: 90,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.90.narrative_1",
			},
		},
	],
	[
		9002,
		{
			quest_id: 90,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				character_name: "{username}",
				text: "quest.90.narrative_2",
			},
		},
	],
	[
		9003,
		{
			quest_id: 90,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.90.narrative_3",
			},
		},
	],
	[
		9004,
		{
			quest_id: 90,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.90.narrative_4",
			},
		},
	],
	[
		9005,
		{
			quest_id: 90,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.90.narrative_5",
			},
		},
	],
	[
		9006,
		{
			quest_id: 90,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				character_name: "{username}",
				text: "quest.90.narrative_6",
			},
		},
	],
	[
		9007,
		{
			quest_id: 90,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.90.narrative_7",
			},
		},
	],
	[
		9008,
		{
			quest_id: 90,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				character_name: "{username}",
				text: "quest.90.narrative_8",
			},
		},
	],
	[
		9009,
		{
			quest_id: 90,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				character_name: "{username}",
				text: "quest.90.narrative_9",
			},
		},
	],
	[
		9010,
		{
			quest_id: 90,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.90.narrative_10",
			},
		},
	],
	[
		9011,
		{
			quest_id: 90,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				character_name: "{username}",
				text: "quest.90.narrative_11",
			},
		},
	],
	[
		9012,
		{
			quest_id: 90,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.90.narrative_12",
			},
		},
	],
	[
		9101,
		{
			quest_id: 91,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.91.narrative_1",
			},
		},
	],
	[
		9102,
		{
			quest_id: 91,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.91.narrative_2",
			},
		},
	],
	[
		9103,
		{
			quest_id: 91,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.91.narrative_3",
			},
		},
	],
	[
		9104,
		{
			quest_id: 91,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.91.narrative_4",
			},
		},
	],
	[
		9105,
		{
			quest_id: 91,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				character_name: "{username}",
				text: "quest.91.narrative_5",
			},
		},
	],
	[
		9106,
		{
			quest_id: 91,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_6,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.91.narrative_6",
			},
		},
	],
	[
		9201,
		{
			quest_id: 92,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_92,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.92.narrative_1",
			},
		},
	],
	[
		9202,
		{
			quest_id: 92,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_92,
				character_name: "{username}",
				text: "quest.92.narrative_2",
			},
		},
	],
	[
		9203,
		{
			quest_id: 92,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_92,
				character_name: "{username}",
				text: "quest.92.narrative_3",
			},
		},
	],
	[
		9204,
		{
			quest_id: 92,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_92,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.92.narrative_4",
			},
		},
	],
	[
		9205,
		{
			quest_id: 92,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_92,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.92.narrative_5",
			},
		},
	],
	[
		9206,
		{
			quest_id: 92,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_92,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.92.narrative_6",
			},
		},
	],
	[
		9207,
		{
			quest_id: 92,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_92,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.92.narrative_7",
			},
		},
	],
	[
		9208,
		{
			quest_id: 92,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_92,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.92.narrative_8",
			},
		},
	],
	[
		9209,
		{
			quest_id: 92,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_92,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.92.narrative_9",
			},
		},
	],
	[
		9210,
		{
			quest_id: 92,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_92,
				character_name: "{username}",
				text: "quest.92.narrative_10",
			},
		},
	],
	[
		9211,
		{
			quest_id: 92,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_92,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.92.narrative_11",
			},
		},
	],
	[
		9212,
		{
			quest_id: 92,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_92,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.92.narrative_12",
			},
		},
	],
	[
		9213,
		{
			quest_id: 92,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_92,
				character_name: "{username}",
				text: "quest.92.narrative_13",
			},
		},
	],
	[
		9214,
		{
			quest_id: 92,
			order_number: 14,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_92,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.92.narrative_14",
			},
		},
	],
	[
		9301,
		{
			quest_id: 93,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.93.narrative_1",
			},
		},
	],
	[
		9302,
		{
			quest_id: 93,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.93.narrative_2",
			},
		},
	],
	[
		9303,
		{
			quest_id: 93,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.93.narrative_3",
			},
		},
	],
	[
		9304,
		{
			quest_id: 93,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.93.narrative_4",
			},
		},
	],
	[
		9305,
		{
			quest_id: 93,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.93.narrative_5",
			},
		},
	],
	[
		9306,
		{
			quest_id: 93,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.93.narrative_6",
			},
		},
	],
	[
		9307,
		{
			quest_id: 93,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.93.narrative_7",
			},
		},
	],
	[
		9308,
		{
			quest_id: 93,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.93.narrative_8",
			},
		},
	],
	[
		9309,
		{
			quest_id: 93,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.93.narrative_9",
			},
		},
	],
	[
		9310,
		{
			quest_id: 93,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.93.narrative_10",
			},
		},
	],
	[
		9311,
		{
			quest_id: 93,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.93.narrative_11",
			},
		},
	],
	[
		9312,
		{
			quest_id: 93,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.93.narrative_12",
			},
		},
	],
	[
		9313,
		{
			quest_id: 93,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.93.narrative_13",
			},
		},
	],
	[
		9314,
		{
			quest_id: 93,
			order_number: 14,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.93.narrative_14",
			},
		},
	],
	[
		9401,
		{
			quest_id: 94,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.94.narrative_1",
			},
		},
	],
	[
		9402,
		{
			quest_id: 94,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.94.narrative_2",
			},
		},
	],
	[
		9403,
		{
			quest_id: 94,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.94.narrative_3",
			},
		},
	],
	[
		9404,
		{
			quest_id: 94,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.94.narrative_4",
			},
		},
	],
	[
		9405,
		{
			quest_id: 94,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.94.narrative_5",
			},
		},
	],
	[
		9406,
		{
			quest_id: 94,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.94.narrative_6",
			},
		},
	],
	[
		9407,
		{
			quest_id: 94,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.94.narrative_7",
			},
		},
	],
	[
		9501,
		{
			quest_id: 95,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.95.narrative_1",
			},
		},
	],
	[
		9502,
		{
			quest_id: 95,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.95.narrative_2",
			},
		},
	],
	[
		9503,
		{
			quest_id: 95,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.95.narrative_3",
			},
		},
	],
	[
		9504,
		{
			quest_id: 95,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.95.narrative_4",
			},
		},
	],
	[
		9505,
		{
			quest_id: 95,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.95.narrative_5",
			},
		},
	],
	[
		9506,
		{
			quest_id: 95,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.95.narrative_6",
			},
		},
	],
	[
		9507,
		{
			quest_id: 95,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				character_name: "{username}",
				text: "quest.95.narrative_7",
			},
		},
	],
	[
		9508,
		{
			quest_id: 95,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.95.narrative_8",
			},
		},
	],
	[
		9509,
		{
			quest_id: 95,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				character_name: "{username}",
				text: "quest.95.narrative_9",
			},
		},
	],
	[
		9510,
		{
			quest_id: 95,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.95.narrative_10",
			},
		},
	],
	[
		9511,
		{
			quest_id: 95,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.95.narrative_11",
			},
		},
	],
	[
		9512,
		{
			quest_id: 95,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK_THIEF,
				backgroundImage: BackgroundImage.QUEST_BG_ART_93,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.95.narrative_12",
			},
		},
	],
	[
		9601,
		{
			quest_id: 96,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_83,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.96.narrative_1",
			},
		},
	],
	[
		9602,
		{
			quest_id: 96,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_83,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.96.narrative_2",
			},
		},
	],
	[
		9603,
		{
			quest_id: 96,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_83,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.96.narrative_3",
			},
		},
	],
	[
		9604,
		{
			quest_id: 96,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_83,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.96.narrative_4",
			},
		},
	],
	[
		9701,
		{
			quest_id: 97,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.97.narrative_1",
			},
		},
	],
	[
		9702,
		{
			quest_id: 97,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.leonard.non_translatable",
				text: "quest.97.narrative_2",
			},
		},
	],
	[
		9703,
		{
			quest_id: 97,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.97.narrative_3",
			},
		},
	],
	[
		9704,
		{
			quest_id: 97,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.97.narrative_4",
			},
		},
	],
	[
		9705,
		{
			quest_id: 97,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.97.narrative_5",
			},
		},
	],
	[
		9706,
		{
			quest_id: 97,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LEONARD,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.leonard.non_translatable",
				text: "quest.97.narrative_6",
			},
		},
	],
	[
		9707,
		{
			quest_id: 97,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.97.narrative_7",
			},
		},
	],
	[
		9708,
		{
			quest_id: 97,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.97.narrative_8",
			},
		},
	],
	[
		9709,
		{
			quest_id: 97,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.97.narrative_9",
			},
		},
	],
	[
		9801,
		{
			quest_id: 98,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.98.narrative_1",
			},
		},
	],
	[
		9802,
		{
			quest_id: 98,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.98.narrative_2",
			},
		},
	],
	[
		9803,
		{
			quest_id: 98,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				character_name: "{username}",
				text: "quest.98.narrative_3",
			},
		},
	],
	[
		9804,
		{
			quest_id: 98,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.98.narrative_4",
			},
		},
	],
	[
		9805,
		{
			quest_id: 98,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				character_name: "{username}",
				text: "quest.98.narrative_5",
			},
		},
	],
	[
		9806,
		{
			quest_id: 98,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.98.narrative_6",
			},
		},
	],
	[
		9807,
		{
			quest_id: 98,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				character_name: "{username}",
				text: "quest.98.narrative_7",
			},
		},
	],
	[
		9808,
		{
			quest_id: 98,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.98.narrative_8",
			},
		},
	],
	[
		9809,
		{
			quest_id: 98,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				character_name: "{username}",
				text: "quest.98.narrative_9",
			},
		},
	],
	[
		9810,
		{
			quest_id: 98,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.98.narrative_10",
			},
		},
	],
	[
		9811,
		{
			quest_id: 98,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				character_name: "{username}",
				text: "quest.98.narrative_11",
			},
		},
	],
	[
		9812,
		{
			quest_id: 98,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.98.narrative_12",
			},
		},
	],
	[
		9813,
		{
			quest_id: 98,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				character_name: "{username}",
				text: "quest.98.narrative_13",
			},
		},
	],
	[
		9814,
		{
			quest_id: 98,
			order_number: 14,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.98.narrative_14",
			},
		},
	],
	[
		9901,
		{
			quest_id: 99,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				character_name: "{username}",
				text: "quest.99.narrative_1",
			},
		},
	],
	[
		9902,
		{
			quest_id: 99,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.99.narrative_2",
			},
		},
	],
	[
		9903,
		{
			quest_id: 99,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				character_name: "{username}",
				text: "quest.99.narrative_3",
			},
		},
	],
	[
		9904,
		{
			quest_id: 99,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.99.narrative_4",
			},
		},
	],
	[
		9905,
		{
			quest_id: 99,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				character_name: "{username}",
				text: "quest.99.narrative_5",
			},
		},
	],
	[
		9906,
		{
			quest_id: 99,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.99.narrative_6",
			},
		},
	],
	[
		9907,
		{
			quest_id: 99,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.99.narrative_7",
			},
		},
	],
	[
		9908,
		{
			quest_id: 99,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.99.narrative_8",
			},
		},
	],
	[
		9909,
		{
			quest_id: 99,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.99.narrative_9",
			},
		},
	],
	[
		9910,
		{
			quest_id: 99,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.99.narrative_10",
			},
		},
	],
	[
		9911,
		{
			quest_id: 99,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.99.narrative_11",
			},
		},
	],
	[
		9912,
		{
			quest_id: 99,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.99.narrative_12",
			},
		},
	],
	[
		9913,
		{
			quest_id: 99,
			order_number: 13,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.99.narrative_13",
			},
		},
	],
	[
		9914,
		{
			quest_id: 99,
			order_number: 14,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.99.narrative_14",
			},
		},
	],
	[
		9915,
		{
			quest_id: 99,
			order_number: 15,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_82,
				character_name: "{username}",
				text: "quest.99.narrative_15",
			},
		},
	],
	[
		10001,
		{
			quest_id: 100,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.100.narrative_1",
			},
		},
	],
	[
		10002,
		{
			quest_id: 100,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.100.narrative_2",
			},
		},
	],
	[
		10003,
		{
			quest_id: 100,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.100.narrative_3",
			},
		},
	],
	[
		10004,
		{
			quest_id: 100,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.100.narrative_4",
			},
		},
	],
	[
		10005,
		{
			quest_id: 100,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.100.narrative_5",
			},
		},
	],
	[
		10006,
		{
			quest_id: 100,
			order_number: 6,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.100.narrative_6",
			},
		},
	],
	[
		10007,
		{
			quest_id: 100,
			order_number: 7,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.100.narrative_7",
			},
		},
	],
	[
		10008,
		{
			quest_id: 100,
			order_number: 8,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.100.narrative_8",
			},
		},
	],
	[
		10009,
		{
			quest_id: 100,
			order_number: 9,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.LEFT,
				character_name: "character.adalbert.non_translatable",
				text: "quest.100.narrative_9",
			},
		},
	],
	[
		10010,
		{
			quest_id: 100,
			order_number: 10,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.ADALBERT,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.100.narrative_10",
			},
		},
	],
	[
		10011,
		{
			quest_id: 100,
			order_number: 11,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.100.narrative_11",
			},
		},
	],
	[
		10012,
		{
			quest_id: 100,
			order_number: 12,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.100.narrative_12",
			},
		},
	],
	[
		10101,
		{
			quest_id: 101,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_101,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.101.narrative_1",
			},
		},
	],
	[
		10102,
		{
			quest_id: 101,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_101,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.101.narrative_2",
			},
		},
	],
	[
		10201,
		{
			quest_id: 102,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_101,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.102.narrative_1",
			},
		},
	],
	[
		10202,
		{
			quest_id: 102,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_101,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.102.narrative_2",
			},
		},
	],
	[
		10301,
		{
			quest_id: 103,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_101,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.103.narrative_1",
			},
		},
	],
	[
		10302,
		{
			quest_id: 103,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_101,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.103.narrative_2",
			},
		},
	],
	[
		10303,
		{
			quest_id: 103,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_101,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.103.narrative_3",
			},
		},
	],
	[
		10401,
		{
			quest_id: 104,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.104.narrative_1",
			},
		},
	],
	[
		10402,
		{
			quest_id: 104,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.104.narrative_2",
			},
		},
	],
	[
		10403,
		{
			quest_id: 104,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.104.narrative_3",
			},
		},
	],
	[
		10404,
		{
			quest_id: 104,
			order_number: 4,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.garrick.non_translatable",
				text: "quest.104.narrative_4",
			},
		},
	],
	[
		10405,
		{
			quest_id: 104,
			order_number: 5,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.GARRICK,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				character_name: "{username}",
				text: "quest.104.narrative_5",
			},
		},
	],
	[
		10501,
		{
			quest_id: 105,
			order_number: 1,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.105.narrative_1",
			},
		},
	],
	[
		10502,
		{
			quest_id: 105,
			order_number: 2,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: "",
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.CENTER,
				character_name: "character.narrator",
				text: "quest.105.narrative_2",
			},
		},
	],
	[
		10503,
		{
			quest_id: 105,
			order_number: 3,
			type: QuestNarrativeTypes.CHARACTER,
			data: {
				image: Avatars.LESTER,
				backgroundImage: BackgroundImage.QUEST_BG_ART_19,
				direction: NarrativeDirection.RIGHT,
				character_name: "character.lester.non_translatable",
				text: "quest.105.narrative_3",
			},
		},
	],
]);

export const narratives = new Map<number, NarrativeItem>([
	...narrativesMain,
	...narrativesSide,
]);
